<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel flex flex-col main-content-pannel-t">
        <div class="flex flex-1" style="width: 70%; margin: 50px auto 30px">
          <p style="margin: 0 20px; padding: 20px; line-height: 1.5; background-color: #eef1fc; border-radius: 5px">Here's you quote! if you have any questions or want to see alternative technicians, please let us know. Once you are ready to proceed with the quote, please go to the next step and sign.</p>
        </div>
        <div class="flex flex-1" style="width: 70%; margin: 0 auto">
          <div class="flex-1 main-content-left">
            <div class="main-pannel">
              <div class="main-pannel-content p-0">
                <div class="tech-resume-info flex items-center justify-center">
                  <div class="flex-1 p-l p-b-0">
                    <h3>{{(consultant.name ? consultant.name : consultant.email) | getNameByEmail}}</h3>
                    <div>
                      <span>Location: {{consultant.location}}</span>
                    </div>
                  </div>
                </div>
                <div class="dashboard-more-info p-l p-b-0">
                  <label>Requirements:</label>
                  <p>{{consultant.bio}}</p>
                  <label>Engagement Length: <span style="color: var(--font-color-lighter); font-weight: 300;">6 MONTH</span></label>
                  <p></p>
                  <label>Estimated Start: <span style="color: var(--font-color-lighter); font-weight: 300;">12/20/2020</span></label>
                  <p></p>
                </div>
                <div class="dashboard-more-info p-l p-b-0">
                  <ul class="admin-dashboard">
                    <li class="flex">
                      <div class="flex-1">
                        <h3>Onsite Technician 1</h3>
                        <p><label>Hours per week:</label>20 HOURS</p>
                        <p><label>Rate:</label>$1.85/HOURS</p>
                      </div>
                      <div class="flex-1">
                        <h3>Assuming 4 week a month</h3>
                        <p class="assuming"><span>$1480</span> /MONTH</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="main-pannel-foot">
              </div>
            </div>
          </div>
          <div class="flex-1 main-content-right"  style="max-width: 50%">
            <div class="main-pannel m-l-l m-r-l m-b-3l">
              <h3 class="main-pannel-header">
                Candidates for onsite technician 1
              </h3>
              <div class="main-pannel-content breakdown-tech p-0" style="max-height: 200px;">
                <div
                    v-for="(consultant, index) in consultants"
                    :key="index"
                    class="flex client-tech-list"
                >
                  <div class="client-tech-resume-info-avatar">
                    <div class="client-tech-resume-info-avatar-container">
                        <span
                            v-if="!consultant.photoUrl"
                        >{{(consultant.name ? consultant.name : consultant.email) | getFirstLetter}}</span>
                      <img v-else :src="consultant.photoUrl" alt />
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="client-tech-name">{{consultant.name}}</div>
                    <div class="flex flex-row client-tech-info" style="justify-content: space-between">
                      <div class="flex-2">
                        <h6>Bio</h6>
                        <p>
                          <span class="font-sm">{{consultant.bio}}</span>
                        </p>
                      </div>
                      <div class="flex-1">
                        <h6>Rate</h6>
                        <p>
                          <span>{{consultant.rate | currencyFilter('$', 2)}}</span> /HOURS
                        </p>
                      </div>
                      <div>
                        <i class="material-icons-outlined align-middle" style="color: #99c66d; font-weight: 900">check</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-pannel m-l-l m-r-l m-b-3l">
              <h3 class="main-pannel-header">
                Candidates for onsite technician 1
              </h3>
              <div class="main-pannel-content breakdown-tech p-0" style="max-height: 200px;">
                <div
                    v-for="(consultant, index) in consultants"
                    :key="index"
                    class="flex client-tech-list"
                >
                  <div class="client-tech-resume-info-avatar">
                    <div class="client-tech-resume-info-avatar-container">
                        <span
                            v-if="!consultant.photoUrl"
                        >{{(consultant.name ? consultant.name : consultant.email) | getFirstLetter}}</span>
                      <img v-else :src="consultant.photoUrl" alt />
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="client-tech-name">{{consultant.name}}</div>
                    <div class="flex flex-row client-tech-info" style="justify-content: space-between">
                      <div class="flex-2">
                        <h6>Bio</h6>
                        <p>
                          <span class="font-sm">{{consultant.bio}}</span>
                        </p>
                      </div>
                      <div class="flex-1">
                        <h6>Rate</h6>
                        <p>
                          <span>{{consultant.rate | currencyFilter('$', 2)}}</span> /HOURS
                        </p>
                      </div>
                      <div>
                        <i class="material-icons-outlined align-middle" style="color: #99c66d; font-weight: 900">check</i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-1">
          <div class="company-gig-footer flex flex-row " style="width: 70%; margin: 0 auto">
            <div class="flex-1">
              <button type="button" class="btn-link">
                <i class="material-icons-outlined align-middle">chevron_left</i> Back
              </button>
            </div>
            <div class="flex-1 text-right">
              <button type="button" class="btn-blue">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/vendor/firebase";

export default {
  data() {
    return {
      consultants: null,
      consultant: null,
      editOpen: false,
    }
  },
  beforeMount() {
    this.bindData();
  },
  methods: {
    bindData: function() {
      this.$bind(
          "consultant",
          db.collection("consultants").doc("05yB86JnnZNN24HOP31Q")
      );
      this.$bind("consultants", db.collection("consultants"));
    },
  }
}
</script>

<style scoped>

</style>
